import { render, staticRenderFns } from "./GatEdit.vue?vue&type=template&id=4f0c40af&scoped=true"
import script from "./GatEdit.vue?vue&type=script&lang=js"
export * from "./GatEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c40af",
  null
  
)

export default component.exports